// extracted by mini-css-extract-plugin
export default {"active":"descriptionOfGoods_active__O3XXe"};